export default __webpack_public_path__ + "static/media/balance-bike.2cd78e4b.jpg";